export default {
      id: "fund-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#fund",
      toString: function () {
        return this.url;
      }
    }